import React from "react";
import "./Footer.css";
import facebook from "../../Images/facebook.png";
import insta from "../../Images/insta.png";
import twitter from "../../Images/whatsapp-white-icon.png";
function Footer() {
  return (
    <div className="footer-container">
      <div className="first-container">
        <h1 className="first-container-title">DISCOVER THE LUXURY..</h1>
        <p className="first-container-desc">Connect With Us</p>
        <div className="logo">
          <a href="https://www.facebook.com/p/Four-seasons-resort-61565738416875/"><img src={facebook} alt="facebook" className="logo-img" /></a>
          <a href="https://www.instagram.com/4seasonresorts/profilecard/?igsh=MWtmd3hyc29jcjR0cQ=="><img src={insta} alt="insta" className="logo-img" /></a>
          <a href="https://wa.me/9241701809"><img src={twitter} alt="whatsapp" className="logo-img" /></a>
        </div>
      </div>
      <div className="second-container">
        <h3 className="container-other-title">Address</h3>
        <ul className="second-container-ul-list">
          <li className="second-container-list">Four Seasons Resort,</li>
          <li className="second-container-list">Tata-Saraikela Main Road,</li>
          <li className="second-container-list">Near Sheyn International School,</li>
          <li className="second-container-list">Adityapur, Kandra,</li>
          <li className="second-container-list">Jamshedpur: 832402</li>
        </ul>
      </div>
      <div className="third-container">
        <h3 className="container-other-title">Get in Touch</h3>
        <ul>
          <li className="second-container-list">Phone: 9241701809</li>
          <li className="second-container-list">Email: fourseasonsresort.24@gmail.com</li>
          {/* <li className="second-container-list">Terms</li>
          <li className="second-container-list">Feedback</li>
          <li className="second-container-list">Help</li> */}
        </ul>
      </div>
    </div>
  );
}

export default Footer;
